import { ReactNode } from 'react';
import { Tooltip } from '../../../../../design-system/tooltip/tooltip';

export type TooltipConfig =
  | {
      isVisible: false;
    }
  | {
      isVisible: true;
      text: string;
    };

type TooltipWrapperProps = {
  tooltipConfig: TooltipConfig;
  children: ReactNode;
};

export const PayeeCheckBadgeWrapper = ({ tooltipConfig, children }: TooltipWrapperProps) => {
  if (!tooltipConfig.isVisible) {
    return children;
  }

  return (
    <Tooltip
      content={tooltipConfig.text}
      trigger={children}
      contentAlign="center"
      contentClassName="bg-black text-white text-[10px] p-2.5"
      arrowConfig={{ isVisible: true, className: 'bg-black fill-black' }}
    />
  );
};
